import Swal from 'sweetalert2'

export const SwalError = Swal.mixin({
  topLayer: true,
  icon: 'error',
  confirmButtonText: 'אישור'
})

export const SwalSuccess = Swal.mixin({
  topLayer: true,
  icon: 'success',
  timer: 1200,
  showConfirmButton: false,
  toast: true,
  position: 'top-end'
})

export const SwalDelete = Swal.mixin({
  topLayer: true,
  icon: 'warning',
  showCancelButton: true,
  title: 'מחיקה',
  confirmButtonText: 'מחק',
  cancelButtonText: 'ביטול'
})
